<template>

  <!-- On Delivery (ON_DELIVERY, RETURNING_TO_HQ) -->
  <route-list-data-table
      title="On Delivery"
      defaultSortField="on_delivery_at"
      defaultSortOrder="dsc"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      routeClickGoTo="route-info" />

</template>

<script>
import RouteListDataTable from '@/components/routes/RouteListDataTable'

export default {
  name: 'RouteListOnDeliveryPage',

  components: {
    RouteListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name', width: '18%' },
        { text: 'Orders', sortable: false, value: 'orders', width: '180px' },
        { text: 'Actions', sortable: false, align: 'center', value: 'id' },
        // { text: 'Delivery Date', value: 'delivery_date' },
        { text: 'Est. Return', value: 'estimated_return_time' },
        { text: 'Vehicle', value: 'vehicle_id' },
        { text: 'Driver', value: 'driver_user_id' },
        { text: 'Delivery Started', value: 'on_delivery_at' },
        { text: 'Status', align: 'start', value: 'route_status' }
      ],
      status: ['ON_DELIVERY', 'RETURNING_TO_HQ'],
      assocs: 'orders,driver,vehicle'
    }
  }
}
</script>

<style scoped>
</style>
